import request from '@/utils/request';

//分页查询小程序码列表
export function getQueryQrCodeGroupPage(values) {
  return request('/wechat/mini/queryQrCodeGroupPage', {
    method: 'POST',
    data: values,
  });
}

//分页查询小程序码列表
export function getWechatQrcodeGroupList(values) {
  return request('/wechat/group/queryGroupPage', {
    method: 'POST',
    data: values,
  });
}

//删除小程序码
export function deleteQrCodeGroup(values) {
  return request('/wechat/mini/deleteQrCodeGroup', {
    method: 'POST',
    data: values,
  });
}
//删除分组
export function deleteGroup(values) {
  return request('/wechat/group/deleteGroup', {
    method: 'POST',
    data: values,
  });
}
//新增分组
export function addGroup(values) {
  return request('/wechat/group/addGroup', {
    method: 'POST',
    data: values,
  });
}
//编辑分组
export function updateGroup(values) {
  return request('/wechat/group/updateGroup', {
    method: 'POST',
    data: values,
  });
}
//查询分组列表
export function getGroupList(values) {
  return request('/wechat/group/queryGroupList', {
    method: 'POST',
    data: values,
  });
}

//停用小程序码
export function stopQrCode(values) {
  return request('/wechat/qrcode/stopQrcode', {
    method: 'POST',
    data: values,
  });
}

//获取小程序码buffer
export function getQrCodeBuffer(values) {
  return request('/wechat/qrcode/queryPic', {
    method: 'POST',
    data: values,
  });
}

//自动回复规则列表
export function getAutoReplyRulePage(values) {
  return request('/wechat/reply/queryReplyRulePage', {
    method: 'POST',
    data: values,
  });
}

//保存新增小程序码
export function saveQrCodeGroup(values) {
  return request('/wechat/mini/saveQrCodeGroup', {
    method: 'POST',
    data: values,
  });
}
//查询小程序码
export function getQueryQrCode(values) {
  return request('/wechat/mini/queryQrCodeGroupInfo', {
    method: 'POST',
    data: values,
  });
}
//更新小程序码
export function updateQrCode(values) {
  return request('/wechat/qrcode/updateQrcode', {
    method: 'POST',
    data: values,
  });
}

//更新小程序码
export function downQrcodeZip(values) {
  return request('/wechat/mini/miniQrCodeExport', {
    method: 'POST',
    data: values,
  });
}
//更新小程序码
export function batchAddQrCode(values) {
  return request('/wechat/qrcode/batchAddQrcode', {
    method: 'POST',
    data: values,
  });
}

//查询二维码
export function qrcodeGroupInfo(values) {
  return request('/activityCoupon/qrcodeGroupInfo', {
    method: 'POST',
    data: values,
  });
}
